import uppyLocaleRu from '@uppy/locales/lib/ru_RU.js';

export default {
  'A modern, customizable file manager component built for Vue.':
    'Современный настраиваемый файловый менеджер, созданный для Vue.',
  'Project Home': 'Страница проекта',
  'If you like it, please follow and ⭐ star on GitHub.':
    'Если вам нравится, подпишитесь и поставьте ⭐ звезду на GitHub.',
  Language: 'Язык',
  Dossier: 'Досье',
  Create: 'Создать',
  Close: 'Закрыть',
  Cancel: 'Отмена',
  Save: 'Сохранить',
  Edit: 'Изменить',
  Crop: 'Обрезать',
  'New Folder': 'Новая папка',
  'New File': 'Новый файл',
  Rename: 'Переименовать',
  Delete: 'Удалить',
  Upload: 'Загрузить',
  Download: 'Скачать',
  Move: 'Переместить',
  Archive: 'Архивировать',
  Unarchive: 'Разархивировать',
  Open: 'Открыть',
  'Open containing folder': 'Открыть расположение',
  Refresh: 'Обновить',
  Preview: 'Предпросмотр',
  'Toggle Full Screen': 'Полный экран',
  'Change View': 'Изменить вид',
  Storage: 'Хранилище',
  'Go up a directory': 'Вверх',
  Go: 'Перейти',
  'Enter folder path:': 'Введите путь к папке:',
  'Invalid path format. Path must be in format: storage://path/to/folder':
    'Неверный формат пути. Путь должен быть в формате: storage://path/to/folder',
  'Invalid storage. Storage "%s" is not available.':
    'Неверное хранилище. Хранилище "%s" недоступно.',
  'Failed to navigate to folder': 'Не удалось перейти в папку',
  'Copy Path': 'Копировать путь',
  'Copy path': 'Копировать путь',
  'Path copied to clipboard': 'Путь скопирован в буфер обмена',
  'Toggle Path Copy Mode': 'Переключить режим копирования пути',
  'Copy Download URL': 'Копировать URL загрузки',
  'Search anything..': 'Поиск...',
  Name: 'Имя',
  'Date modified': 'Дата изменения',
  'Date uploaded': 'Дата выгрузки',
  Type: 'Тип',
  Size: 'Размер',
  Date: 'Дата',
  Filepath: 'Путь до файла',
  'Folder Name': 'Название папки',
  'File Name': 'Название файла',
  'Move files': 'Переместить файлы',
  'Yes, Move!': 'Переместить',
  'Delete files': 'Удалить файлы',
  Password: 'Пароль',
  'The file is password-protected from editing. Enter the password to delete it.': 'Файл защищён паролем от редактирования. Чтобы удалить его, введите пароль.',
  'Yes, Delete!': 'Удалить',
  'Upload Files': 'Загрузить файлы',
  'No files selected!': 'Файлы не выбраны!',
  'Select Files': 'Выбрать файлы',
  'Archive the files': 'Архивировать файлы',
  'Unarchive the files': 'Разархивировать файлы',
  'The archive will be unarchived at': 'Архив будет разархивирован в',
  'Archive name. (.zip file will be created)': 'Название архива. (будет создан .zip файл)',

  'Create a new folder': 'Создать новую папку',
  'Create a new file': 'Создать новый файл',
  'Create folder': 'Создать папку',
  'Create Word': 'Создать Word',
  'Create Excel': 'Создать Excel',
  More: 'Дополнительно',
  'Folder (create)': 'Папку',
  'Word document (create)': 'Документ Word',
  'Excel workbook (create)': 'Книгу Excel',
  History: 'История',
  'Give access': 'Дать доступ',
  'Access settings': 'Настройка доступа',
  'No access subjects': 'Нет пользователей для настройки доступа',
  'Failed to load access settings': 'Не удалось загрузить настройки доступа',
  'Can read': 'Чтение',
  'Can edit': 'Редактирование',
  'Upload to folder': 'Загрузить в папку',
  Path: 'Путь',
  Favorites: 'Избранное',
  Trash: 'Корзина',
  'My trash': 'Моя корзина',
  'No favorites': 'Нет избранного',
  'Add to favorites': 'Добавить в избранное',
  'Remove from favorites': 'Убрать из избранного',
  'File folder': 'Папка с файлами',
  'Selected items will be downloaded as an archive': 'Выбранные элементы будут скачаны архивом',
  'Selected file will be downloaded': 'Выбранный файл будет скачан',
  'Are you sure you want to delete these files?': 'Вы уверены, что хотите удалить эти файлы?',
  "I'm sure delete it, This action cannot be undone.":
    'Я подтверждаю, что хочу удалить это. Это действия нельзя отменить.',
  'Search results for': 'Результаты поиска по',
  '%s item(s) selected.': '%s выбраны.',
  '%s is renamed.': '%s переименован.',
  'File extension cannot be changed.': 'Нельзя менять расширение файла.',
  'This is a readonly storage.': 'Данное хранилище только для чтения.',
  '%s is created.': '%s создан.',
  'Files moved.': 'Файлы перемещены.',
  'Files deleted.': 'Файлы удалены.',
  'The file unarchived.': 'Файл разархивирован',
  'The file(s) archived.': 'Файл(-ы) архивированы',
  'Updated.': 'Обновлено.',
  'No search result found.': 'Ничего не найдено',
  'Are you sure you want to move these files?': 'Вы уверены, что хотите переместить эти файлы?',
  'File Size': 'Размер файла',
  'Last Modified': 'Последнее изменение',
  'Select Folders': 'Выбрать папки',
  'Clear all': 'Очистить все',
  'Clear only successful': 'Очистить только успешные',
  'Drag and drop the files/folders to here.': 'Перетащите файлы/папки сюда.',
  'You can drag & drop files anywhere while this modal is open.':
    'Вы можете перетаскивать файлы в любое место, пока это окно открыто.',
  Canceled: 'Отменено',
  Done: 'Готово',
  'Network Error, Unable establish connection to the server or interrupted.':
    'Ошибка сети, не удалось установить соединение с сервером или соединение было прервано.',
  'Pending upload': 'Ожидание загрузки',
  'Please select file to upload first.': 'Пожалуйста, выберите файл для загрузки.',
  Status: 'Статус',
  'Conflict: choose an action': 'Конфликт: выберите действие',
  'Will be uploaded': 'Будет загружен',
  'A file named "%s" already exists in the destination folder': 'В папке назначения уже есть файл «%s»',
  'The destination folder already contains files with the same names': 'В папке назначения уже есть файлы с такими именами',
  'Replacing creates a new version of the file.': 'При замене будет создана новая версия файла.',
  'Other files will be uploaded.': 'Остальные файлы будут загружены.',
  'Replace the file in the destination folder': 'Заменить файл в папке назначения',
  'Replace the files in the destination folder': 'Заменить файлы в папке назначения',
  'Skip this file': 'Пропустить этот файл',
  'Skip these files': 'Пропустить эти файлы',
  'Cancel upload': 'Отменить загрузку',
  Skipped: 'Пропущено',
  About: 'О компоненте',
  Settings: 'Настройки',
  Shortcuts: 'Горячие клавиши',
  Reset: 'Сброс',
  Escape: 'Выход',
  Search: 'Поиск',
  'Toggle Sidebar': 'Переключить боковую панель',
  'Open Settings': 'Открыть настройки',
  'Reset all settings to default': 'Сбросить все настройки настройки по умолчанию',
  'Saved.': 'Сохранено.',
  'Reset Settings': 'Сбросить настройки',
  'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
    'Загрузка не работает? Вы можете попробовать щелкнуть правой кнопкой мыши по кнопке "Скачать", выбрать "Сохранить ссылку как...".',
  Theme: 'Тема',
  'Target Directory': 'Целевая директория',
  Select: 'Выбрать',
  'Select this folder': 'Выбрать эту папку',
  Selected: 'Выбрано',
  'Ctrl/Cmd + click to select multiple files': 'Ctrl/Cmd + клик — выбрать несколько файлов',
  'Ctrl/Cmd + click to add files; Shift + click to select a range': 'Ctrl/Cmd + клик — добавить файлы; Shift + клик — выбрать диапазон',
  'This folder is empty.': 'Эта папка пуста.',
  'Show thumbnails': 'Показать миниатюры',
  'Persist Path': 'Сохранить путь',
  'Metric Units': 'Метрические единицы',
  'Select All': 'Выбрать все',
  'Pinned Folders': 'Закрепленные папки',
  'No folders pinned': 'Нет закрепленных папок',
  'No folders': 'Нет папок',
  'Pin Folder': 'Закрепить папку',
  'Unpin Folder': 'Открепить папку',
  'Project home': 'Домашняя страница проекта',
  'Customize your experience with the following settings':
    'Настройте свой опыт с помощью следующих настроек',
  File: 'Файл',
  View: 'Вид',
  Tools: 'Инструменты',
  Help: 'Помощь',
  Exit: 'Выход',
  'Deselect All': 'Отменить все',
  Cut: 'Вырезать',
  Copy: 'Копировать',
  Paste: 'Вставить',
  'Grid View': 'Сетка',
  'List View': 'Список',
  'Tree View': 'Дерево',
  'Show Thumbnails': 'Показать миниатюры',
  'Full Screen': 'Полный экран',
  items: 'элементов',
  selected: 'выбрано',

  Git: 'Git',
  Forward: 'Вперед',
  Back: 'Назад',
  'Go to Folder': 'Перейти в папку',
  Sorting: 'Сортировка',
  Asc: 'По возрастанию',
  Desc: 'По убыванию',
  None: 'Нет',
  Show: 'Показать',
  'All items': 'Все элементы',
  'Files only': 'Только файлы',
  'Folders only': 'Только папки',
  'Show hidden files': 'Показать скрытые файлы',
  'Copy files': 'Копировать файлы',
  'Are you sure you want to copy these files?': 'Вы уверены, что хотите скопировать эти файлы?',
  'Yes, Copy!': 'Да, копировать!',
  'Files copied.': 'Файлы скопированы.',
  Browse: 'Обзор',
  'Create a copy instead of moving': 'Создать копию вместо перемещения',
  'No items selected': 'Элементы не выбраны',
  'Item copied to clipboard': 'Элемент скопирован в буфер обмена',
  '%s items copied to clipboard': '%s элементов скопировано в буфер обмена',
  'Item cut to clipboard': 'Элемент вырезан в буфер обмена',
  '%s items cut to clipboard': '%s элементов вырезано в буфер обмена',
  'No items in clipboard': 'В буфере обмена нет элементов',
  'Cannot paste items to the same directory': 'Нельзя вставить элементы в ту же папку',
  'Please select a destination directory': 'Выберите целевую папку',
  'Cannot move/copy item to itself or its parent/child directory':
    'Нельзя переместить или скопировать элемент в себя, родительскую или дочернюю папку',
  'Invalid destination directory': 'Некорректная целевая папка',
  'Failed to create file': 'Не удалось создать файл',
  'Failed to create folder': 'Не удалось создать папку',
  'Failed to delete files': 'Не удалось удалить файлы',
  'Failed to transfer files': 'Не удалось переместить или скопировать файлы',
  'Failed to save file': 'Не удалось сохранить файл',
  'Failed to save image': 'Не удалось сохранить изображение',
  'Failed to rename': 'Не удалось переименовать',
  'Failed to archive files': 'Не удалось архивировать файлы',
  'Failed to unarchive': 'Не удалось разархивировать',
  'Download failed': 'Не удалось скачать файл',
  // FinderError.code → toast (docparser)
  'errors.folder_exists': 'Папка «%s» уже существует',
  'errors.file_exists': 'Файл «%s» уже существует',
  'errors.destination_exists': 'Объект «%s» уже существует',
  'errors.folder_name_reserved': 'Имя папки «%s» зарезервировано',
  'errors.item_not_found': 'Объект досье не найден',
  'errors.root_immutable': 'Корень хранилища нельзя изменить',
  'errors.access_denied': 'Нет доступа к выбранному объекту досье',
  'errors.access_acl_denied': 'Нет доступа для настройки прав досье',
  'errors.user_not_found': 'Пользователь «%s» не найден',
  'errors.role_not_found': 'Роль «%s» не найдена',
  'errors.nothing_selected': 'Ничего не выбрано',
  'errors.destination_required': 'Укажите целевую папку',
  'errors.invalid_self_target': 'Нельзя копировать или перемещать папку в саму себя',
  'errors.upload_empty': 'Не загружено ни одного файла',
  'errors.upload_invalid_names': 'Некорректные имена загружаемых файлов',
  'errors.wrong_password': 'Неверный пароль для файла «%s»',
  'errors.archive_not_found': 'Архив не найден',
  'errors.invalid_archive': 'Некорректный или небезопасный архив',
  'errors.conversion_input': 'Укажите хотя бы один файл или id',
  'errors.conversion_limit': 'За один раз можно отправить не более %s файлов',
  'errors.conversion_expired': 'Результат конвертации устарел, запустите снова',
  'errors.projects_disabled': 'Хранилище проектов недоступно',
  'errors.projects_read_only': 'Хранилище проектов доступно только для чтения',
  'errors.projects_path_invalid': 'Некорректный путь или идентификатор проекта',
  'errors.range_invalid': 'Некорректный диапазон запроса',
  'errors.storage_misconfigured': 'Хранилище досье настроено неверно',
  'errors.storage_unavailable': 'Хранилище временно недоступно',
  'errors.index_stale': 'Индекс проектов устарел',
  'errors.index_unavailable': 'Индекс проектов недоступен',
  'errors.auth_required': 'Требуется авторизация',
  'errors.bad_request': 'Некорректный запрос',
  'Toggle Tree View': 'Переключить дерево папок',
  'Search Files': 'Поиск файлов',
  Filter: 'Фильтр',
  'Show Hidden Files': 'Показать скрытые файлы',
  Version: 'Версия',
  License: 'Лицензия',
  'Previous file': 'Предыдущий файл',
  'Next file': 'Следующий файл',
  'load more': 'Загрузить ещё',
  'Select Target Folder': 'Выбрать целевую папку',
  Storages: 'Хранилища',
  Loading: 'Загрузка',
  Uploading: 'Загрузка',
  'Unknown Error': 'Неизвестная ошибка',
  'Search files': 'Поиск файлов',
  'Failed to open containing folder': 'Не удалось открыть содержащую папку',
  'Include subfolders': 'Включить подпапки',
  'More actions': 'Дополнительные действия',
  'Open Containing Folder': 'Открыть содержащую папку',
  'Searching...': 'Поиск...',
  'No results found': 'Результаты не найдены',
  'Found %s results': 'Найдено результатов: %s',
  'Search failed': 'Не удалось выполнить поиск',
  'Search Options': 'Параметры поиска',
  'All Files': 'Все файлы',
  'Small (< 1MB)': 'Маленькие (< 1MB)',
  'Medium (1-10MB)': 'Средние (1-10MB)',
  'Large (> 10MB)': 'Большие (> 10MB)',
  'Start typing to search files. Use options to filter or include subfolders.':
    'Начните вводить, чтобы искать файлы. Используйте параметры для фильтрации или включения вложенных папок.',
  uppy: uppyLocaleRu,
};
